<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12" md="6" class="mt-3 mb-1">
                <b-form-group>
                  <label for="departmentId"
                    >กอง <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="กอง"
                    v-slot="{ errors }"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="selectedDepartment"
                      :options="departmentOptions"
                      @input="selectOnInput"
                      class="mt-1 pl-1"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mt-3 mb-1">
                <b-form-group label="รหัสบริษัท">
                  <b-form-input
                    class="col-6"
                    v-model="conclusionDetailData.compId"
                    readonly="readonly"
                  />
                </b-form-group>

                <b-form-group>
                  <label for="comp"
                    >บริษัท <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="บริษัท"
                    v-slot="{ errors }"
                  >
                    <vue-autosuggest
                      :v-model="conclusionDetailData.compName"
                      :value="conclusionDetailData.compName"
                      :suggestions="filteredOptions"
                      :limit="limit"
                      :input-props="inputProps"
                      class="col-6"
                      @selected="onSelected"
                      @input="onInputChange"
                      :get-suggestion-value="getSuggestionValue"
                    >
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item">{{
                          suggestion.item.label
                        }}</span>
                      </template>
                    </vue-autosuggest>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="ที่ตั้ง/ที่อยู่">
                  <CompanyAddress
                    v-if="address !== null && address !== undefined"
                    :address="address"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mt-3 mb-1">
                <b-form-group>
                  <label for="detail"
                    >มติที่ประชุม <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="มติที่ประชุม"
                    v-slot="{ errors }"
                  >
                    <b-form-textarea
                      v-model="conclusionDetailData.detail"
                      rows="5"
                    ></b-form-textarea>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-row
                v-for="file in this.attachFiles"
                :key="file.attachId"
                class="col-12 m-1 col-md-6"
              >
                <b-col md="10">
                  <a
                    :href="file.filePath"
                    :download="file.fileName"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-arrow-down-circle"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="8 12 12 16 16 12" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                    </svg>
                    {{ file.fileName }}
                  </a>
                </b-col>
                <b-col md="2" class="d-flex justify-content-center">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="onAttachFileDelete(file.attachId)"
                  >
                    <feather-icon icon="Trash2Icon" size="24" />
                  </a>
                </b-col>
              </b-row>

              <b-col cols="12" md="6">
                <b-form-group label="เอกสารแนบ">
                  <b-form-file
                    @change="onUploadFileChanged"
                    ref="file-input"
                    multiple
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12"></b-col>

              <b-col cols="12" md="6" class="mb-5">
                <b-form-group label="สถานะการใชข้งาน">
                  <b-form-radio-group
                    id="isActive"
                    v-model="conclusionDetailData.isActive"
                    :options="activeOptions"
                    name="radio-is-active"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
import { VueAutosuggest } from "vue-autosuggest";
import * as companyStore from "@/store/api/company/index.js";

import * as storeMaster from "@/store/api/master/index.js";
import * as conclusionDetailStore from "@/store/api/conclusion/detail.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import CompanyAddress from "../components/CompanyAddress.vue";

import VueSelect from "vue-select";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    CompanyAddress,
    VueAutosuggest,
    VueSelect,
    ValidationObserver,
    ValidationProvider,
    extend,
  },
  data() {
    return {
      conclusionDetailData: {
        conclusionId: null,
        isActive: true,
      },
      attachFiles: [],
      address: {},
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      departmentOptions: [],
      selectedDepartment: {},

      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      this.getDepartment();
    } else {
      const id = this.$route.query.id;
      this.getConclusionDetailById(id);
    }

    if (this.$route.query.conclusionId == null) {
      window.open(
        _this.$router.resolve({
          name: "Conclusion",
        }).href,
        "_self"
      );
    }

    this.conclusionDetailData.conclusionId = parseInt(
      this.$route.query.conclusionId
    );
  },
  methods: {
    getConclusionDetailById(id) {
      const _this = this;

      conclusionDetailStore
        .getById(id)
        .then((response) => {
          _this.conclusionDetailData = response.data.data.conclusionDetailData;
          _this.attachFiles = response.data.data.attachFiles;

          _this.getDepartment();

          // get company address detial
          companyStore
            .getAddressDetail(_this.conclusionDetailData.compId)
            .then((response) => {
              _this.address = response.data.data;
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getDepartment() {
      const _this = this;
      storeMaster
        .getDepartment(2)
        .then(function(response) {
          _this.departmentOptions = response.data.data;

          if (_this.conclusionDetailData.departmentId !== null) {
            const selectOption = _this.departmentOptions.find((value) => {
              return value.value === _this.conclusionDetailData.departmentId;
            });
            _this.selectedDepartment = selectOption;
          } else {
            _this.selectedDepartment = _this.departmentOptions.selectOptions[0];
          }

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    onSelected(option) {
      const _this = this;

      this.conclusionDetailData.compName = option.item.label;
      this.conclusionDetailData.compId = option.item.value;
      console.log(option);
      // get company address detial
      companyStore
        .getAddressDetail(option.item.value)
        .then((response) => {
          _this.address = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onInputChange(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      companyStore
        .getByName(text)
        .then((response) => {
          console.log("response", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredCompany = response.data.data.slice(0, this.limit);
          _this.filteredOptions = [
            {
              data: filteredCompany,
            },
          ];

          console.log("_this", _this.filteredOptions);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSuggestionValue(suggestion) {
      console.log("suggestion item", suggestion.item);
      this.conclusionDetailData.compId = suggestion.item.value;
      return suggestion.item.label;
    },
    selectOnInput() {
      console.log("on input");
      this.$forceUpdate();
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.conclusionDetailData.updateBy = userData.userId();
            _this.conclusionDetailData.departmentId =
              _this.selectedDepartment.value;

            const params = {
              conclusionDetailData: _this.conclusionDetailData,
              attachFiles: _this.attachFiles,
            };

            conclusionDetailStore
              .updateItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "ConclusionDetail",
                      query: { id: _this.conclusionDetailData.conclusionId },
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "role" }).href, "_self");
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }
      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }
      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            keyId: this.complaintId,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>
